import $ from 'jquery';
import formSend from '@utils/form-send';

import '@utils/jquery/button-set-state';
import '@utils/jquery/disable-enter-submit';

export const elements =
{
    call: '.js-GlobalForm-Call',
    form: '.js-GlobalForm-Form'
};

export const send = function($button)
{
    const $form = $button.parents('form');
    formSend
    (
        {
            form: $form,
            validation:
            {
                type: 'form'
            },
            callbacks:
            {
                before: () => {
                    $button.buttonSetState('inProgress');
                },
                always: () => {
                    $button.buttonSetState('backDefault');
                }
            }
        }
    );
};

export const onClick = function(event)
{
    event.preventDefault();
    send($(this));
};

export default
{
    init(params)
    {
        const $button = params.$document.find(elements.call);

        params.$document
            .off('click', elements.call)
            .on('click', elements.call, onClick);
        params.$document.find(elements.form).disableEnterSubmit($.proxy(send, null, $button));
    },
};



// WEBPACK FOOTER //
// ./src/RMPL/CoreBundle/Resources/public/js/ui/form/submit.js